module.exports = __webpack_public_path__ + "005.de5e9d20.png";